import { Component, Node, _decorator } from 'cc';
import I18n from '../../../I18n/I18n';
import GameDependency from '../../../System/GameDependency';
import Delay from '../../Utils/Delay';
import SupportLanguage from '../../../I18n/SupportLanguage';

const { ccclass } = _decorator;

@ccclass('LocalizedComponent')
export default abstract class LocalizedComponent<T extends Component | Node> extends GameDependency {
    private _target: T = null;

    public get target(): T {
        if (!this._target) {
            this._target = this.getTarget();
            if (!this._target) {
                throw new Error('Target is not set');
            }
        }
        return this._target;
    }
    public set target(component: T) {
        this._target = component;
    }

    protected get i18n() {
        return this.game.i18n;
    }

    protected async onEnable() {
        this.i18n.on(I18n.EVENT_TYPE.LanguageChanged, this.onLanguageChange, this);
        if (!this.i18n.currentLanguage) {
            if (this.i18n.isLoadingLanguage) {
                await this.i18n.waitForLanguageLoaded();
            } else {
                await Delay.event(I18n.EVENT_TYPE.LanguageChanged, this.game.i18n);
            }
        } else {
            this.onLanguageChange();
        }
    }

    protected onDisable() {
        this.i18n.off(I18n.EVENT_TYPE.LanguageChanged, this.onLanguageChange, this);
    }

    protected abstract getTarget(): T;

    /**
     * @param language used by extension
     */
    protected abstract onLanguageChange(language?: SupportLanguage): void;
}
